import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import moment from "moment";
import packingService from "../Services/packingService"; // your axios service

const AddPackingList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderData } = location.state || {};

  const [updateProducts, setUpdateProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [loading, setLoading] = useState(false);

  const processOrderDetails = (inputData) => {
    if (!inputData?.details?.length) return null;
    return inputData.details.map((item) => ({
      ...item,
      quantity: item.quantity || 0,
      price: item.quote_price || 0,
      weight: item.weight || 0,
    }));
  };

  useEffect(() => {
    if (orderData && updateProducts.length === 0) {
      const processed = processOrderDetails(orderData);
      if (processed) setUpdateProducts(processed);
    }
  }, [orderData]);

  const handleFileSelect = (e) => {
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => setFile(e.target.result);
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const proceedFileRead = () => {
    if (!file) return toast.error("Please upload a file!");
    const workbook = xlsx.read(file, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = xlsx.utils.sheet_to_json(worksheet);
    setUpdateProducts(json);
  };

  const totalPrice = updateProducts.reduce(
    (acc, item) => acc + item.quantity * parseFloat(item.quote_price),
    0
  );

  // Submit packing using your service
  const handleSubmit = async () => {
    if (!updateProducts.length) return toast.error("No products to submit!");

    setLoading(true);

    const packing = {
      order: orderData.id,
      //customer: orderData.customer_company_name,
      customer: orderData.customer,
      customer_email: orderData.customer_email,
      status: orderData.status,
      customer_order_number: orderData.reference_no,
      date: moment().format("YYYY-MM-DD"),
      products: updateProducts.map((item) => ({
        partnumber: item.vendor_code || "",
        maker: item.brand || "",
        quantity: item.quantity || 0,
        //price: item.price || 0,
        weight: item.weight || 0,
        description: item.title || "",
      })),
      total_price: totalPrice,
    };

    try {
      await packingService.create(packing);
      toast.success("Packing list created successfully!");
      navigate("/packinglist");
    } catch (err) {
      console.error("Failed to create packing:", err);
      toast.error("Failed to create packing list!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {!orderData ? (
        <p className="text-red-500 font-bold text-xl text-center mt-20">
          No order data found.
        </p>
      ) : (
        <>
          <div className="text-3xl font-bold text-secondary text-center mb-5">
            Add Packing for Order: GAP-{orderData.id}
          </div>

          {/* <div className="bg-gray-50 rounded-xl border p-4 mb-6">
            <p>
              <strong>Customer:</strong> {orderData.customer_company_name}
            </p>
            <p>
              <strong>Phone:</strong> {orderData.phone}
            </p>
            <p>
              <strong>Email:</strong> {orderData.customer_email}
            </p>
            <p>
              <strong>Status:</strong> {orderData.status}
            </p>
          </div> */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
              <p className="text-gray-500 text-sm">Customer</p>
              <h3 className="font-semibold text-lg text-blue-600">
                {orderData.customer_company_name}
              </h3>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
              <p className="text-gray-500 text-sm">Phone</p>
              <h3 className="font-medium">{orderData.phone}</h3>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
              <p className="text-gray-500 text-sm">Email</p>
              <h3 className="font-medium">{orderData.customer_email}</h3>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
              <p className="text-gray-500 text-sm">Status</p>
              <h3 className="font-medium">{orderData.status}</h3>
            </div>
          </div>
          {updateProducts.length > 0 ? (
            <>
              <div className="bg-white rounded-xl border p-4 shadow-md">
                <h2 className="text-2xl font-bold text-primary text-center mb-4">
                  Products to Pack
                </h2>
                <table className="min-w-full border border-gray-200 text-sm">
                  <thead className="bg-gray-100 text-gray-700 uppercase text-xs text-left">
                    <tr>
                      <th className="py-2 pl-4">Sr No.</th>
                      <th className="py-2 pl-4">Vendor Code</th>
                      <th className="py-2 pl-4">Brand</th>
                      <th className="py-2 pl-4">Weight</th>
                      <th className="py-2 pl-4">Price</th>
                      <th className="py-2 pl-4">Quantity</th>
                      <th className="py-2 pl-4">Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {updateProducts.map((item, index) => {
                      const total = item.quantity * item.price;
                      return (
                        <tr key={index} className="bg-gray-100">
                          <td className="pl-4 py-2">{index + 1}</td>
                          <td className="pl-4 py-2">{item.vendor_code}</td>
                          <td className="pl-4 py-2 font-bold">{item.brand}</td>
                          <td className="pl-4 py-2">{item.weight}</td>
                          <td className="pl-4 py-2">{item.quote_price} AED</td>
                          <td className="pl-4 py-2">{item.quantity}</td>
                          <td className="pl-4 py-2 font-bold">
                            {total.toFixed(2)} AED
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="bg-gray-200 font-bold">
                    <tr>
                      <td colSpan="6" className="pl-4 py-2 text-right">
                        Total Price:
                      </td>
                      <td className="pl-4 py-2">{totalPrice.toFixed(2)} AED</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="flex justify-end mt-6">
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className={`px-6 py-3 rounded-lg text-white font-medium ${
                    loading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-black hover:rounded-full duration-300 transition-all"
                  }`}
                >
                  {loading ? "Saving..." : "Save Packing"}
                </button>
              </div>
            </>
          ) : (
            <div className="bg-black rounded-2xl py-8 mt-6 px-10 flex flex-col items-center shadow-2xl border border-gray-800">
              <h2 className="text-2xl font-bold text-white text-center mb-6 tracking-wide">
                Choose How You Want to Proceed
              </h2>

              <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
                <button
                  className={`relative px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 ${
                    selectedOption === "upload"
                      ? "bg-neutral-700 text-white shadow-md"
                      : "bg-neutral-800 text-gray-300 hover:bg-neutral-700 hover:text-white"
                  }`}
                  onClick={() => setSelectedOption("upload")}
                >
                  Upload Excel File
                </button>

                <button
                  className={`relative px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 ${
                    selectedOption === "continue"
                      ? "bg-neutral-700 text-white shadow-md"
                      : "bg-neutral-800 text-gray-300 hover:bg-neutral-700 hover:text-white"
                  }`}
                  onClick={() => {
                    const processed = processOrderDetails(orderData);
                    if (processed) setUpdateProducts(processed);
                  }}
                >
                  Without File
                </button>
              </div>

              {selectedOption === "upload" && (
                <div className="w-full">
                  <div className="flex flex-row justify-between items-center w-full bg-neutral-800 p-3 rounded-xl shadow-inner">
                    <input
                      onChange={(e) => handleFileSelect(e)}
                      type="file"
                      className="w-full text-white px-4 py-2 bg-neutral-900 rounded-l-lg border border-neutral-700 focus:outline-none
                                 file:mr-4 file:py-2 file:px-5 file:rounded-lg
                                 file:border-0 file:text-sm file:font-medium
                                 file:bg-blue-600 file:text-white hover:file:bg-blue-700 transition"
                    />
                    <button
                      onClick={proceedFileRead}
                      className="bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-r-lg text-white font-semibold transition duration-200"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </main>
  );
};

export default AddPackingList;
